<template>
  <div v-bind="$attrs">
    <div 
      :class="dropdownClass"
      class="dropdown">

      <div class="dropdown-trigger">
        <div 
          :class="inputClass"
          class="control has-icons-left has-icons-right">
          <input
            ref="input"
            class="input"
            :required="required"
            :value="searchStr"
            @focus="focused = true"
            @blur="focused = false"
            @input="debounceSearch"
            @click="selectText()"
            :placeholder="placeholder">
          <span class="icon is-small is-left">
            <i class="fas fa-search"></i>
          </span>
          <span
            v-if="searchStr != null"
            @click="clear()" 
            class="icon is-small is-right is-clickable">
            <i class="fas fa-times"></i>
          </span>
        </div>
      </div>

      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <span 
            v-if="projects.length == 0" 
            class="has-text-grey dropdown-item">
            <span v-if="searchStr != null && !loading">
              No projects found
            </span>
            <span v-if="searchStr != null && loading">
              loading...
            </span>
            <span v-if="searchStr == null">
              Please enter your search terms
            </span>
          </span>
          <a 
            v-else
            v-for="project in projects"
            :key="project.id"
            @mousedown="select(project)"
            class="dropdown-item">
            {{ project.project_name }}
          </a>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import validatable from '@/mixins/validatable'

export default {
  props: {
    value: {
      type: [Number, String, Object],
    },
    searchInput: {
      type: [String, Number]
    },
    isFullwidth: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean
    },
    project: {
      type: Object
    },
    productBrand: {
      type: String
    },
    projectStage: {
      type: String
    },
    placeholder: {
      type: [String, Number],
      default: 'Search projects'
    }
  },
  mixins: [validatable],
  data() {
    return {
      timeout: null,
      searchStr: null,
      loading: false,
      projects: [],
      focused: false
    }
  },
  computed: {
    dropdownClass() {
      return {
        'is-fullwidth': this.isFullwidth,
        'is-active': this.focused
      }
    },
    inputClass() {
      return {
        'is-loading': this.loading
      }
    }
  },
  watch: {
    'pagination.page'() {
      this.searchProjects(this.value);
    }
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      if (this.value) {
        this.$http.project.get(this.value).then(resp => {
          this.searchStr = resp.data.project_name;
          this.$emit('update:project', resp.data);
          this.$emit('updateProject', resp.data);
        });
      }

      if (this.searchInput) {
        this.searchStr = this.searchInput;
      }
    },
    debounceSearch(event) {
      this.searchStr = event.target.value;
      this.$emit('update:searchInput', event.target.value);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchProjects(event.target.value)
      }, 500)
    },
    searchProjects(v) {
      if(v) {
        this.loading = true;
        this.$http.projects.search({
          q: v, product_brand: this.productBrand, stage: this.projectStage
        }).then(resp => {
          this.projects = resp.data.results;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    select(project) {
      this.validate(project.id);
      this.searchStr = project.project_name;
      this.$emit('update:searchInput', project.project_name);
      this.$emit('input', project.id);
      this.$emit('update:project', project);
      this.$emit('updateProject', project);
    },
    clear() {
      this.searchStr = null;
      this.$emit('update:searchInput', this.searchStr);
      this.$emit('input', null);
      this.$emit('update:project', null);
      this.$emit('updateProject', null);
      this.projects = [];
      this.validate(this.value);
    },
    selectText() {
      this.$refs.input.select();
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown.is-fullwidth {
  width: 100% !important;
  .dropdown-trigger {
    width: 100%;
  }
}

.is-clickable {
  cursor: pointer;
  pointer-events: initial !important;
}
</style>
